import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    width: calc(100% - (${theme.spacing.containerPadding} * 2));
    padding: ${theme.spacing.containerPadding};
    max-width: ${theme.spacing.maxWidth};
    margin-left: auto;
    margin-right: auto;
  `}
`
